import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const standardCollapseCss = {
  width: "100%",
};

export const dropdownContentCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  cursor: "pointer",
};

export const standardElementCss = {
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "150%",
  color: ui.neutral[700],
  width: "fit-content",
};

export const dropdownIconCss = {
  width: "16px",
  height: "16px",
  path: {
    strokeWidth: 4,
  },
};

export const dropdownChildrenItemsCss = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
};

export const standardDescriptionCss = {
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "171%",
  color: ui.neutral[500],
  marginTop: "4px",
};

export const standardLinkCss = {
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "112%",
  color: ui.core[700],
  marginTop: "4px",
};

export const standardElementWithReadingSkillCss = {
  ...standardElementCss,
  marginRight: "4px",
};

export const readingSkillTitleCss = {
  fontWeight: "bold",
  margin: 0,
  marginRight: "2px",
};

export const readingSkillAndChevronContainerCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const dropdownContentWithReadingSkillCss = {
  display: "flex",
  flexWrap: "wrap",
  cursor: "pointer",
};
